
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import ViewsSelector from "@/views/viewsSelection/ViewsSelection.vue";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";

@Component({ components: { ViewsSelector, AsyncPageLoader } })
export default class AccessRightsComponent extends Vue {
  public accessRight = null;
  public asyncPageLoader = false;
  public filteredViews = new Array<any>();
  public disableSubmitbutton = false;

  get user() {
    return this.$store.state.user;
  }
  get imageFile() {
    return this.$store.state.imageFile;
  }

  public saveInformation() {
    return { status: true };
  }

  public async updateAccessRight() {
    let valid = await this.$validator.validateAll();
    if (!valid) {
      this.$snotify.error("Please fix the validation errors!");
      return;
    }
    if (this.filteredViews.length == 0) {
      this.$snotify.error(
        "Please give one of the access right to user through user can login to the application"
      );
      return;
    }
    this.disableSubmitbutton = true;
    this.$showLoader(true);
    this.user.views = JSON.parse(JSON.stringify(this.filteredViews));
    this.user["clientCall"] =
      this.$route.path == "/superAdmin/updateClient" ? true : false;
    await this.$store.dispatch("updateStore", {
      user: this.user,
    });
    let response = null;
    if (this.$route.query.userId) {
      response = await Axios.post(
        API_STORE.CONFIG + "updateAccessRight",
        this.user,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
    } else {
      let formData = new FormData();
      for (let i = 0; i < this.imageFile.length; i++) {
        let file = this.imageFile[i];
        formData.append("file", file, file.categoryName);
      }
      formData.append("jsonData", JSON.stringify(this.user));
      response = await Axios.post(
        API_STORE.CONFIG + "saveUserDetail",
        formData,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
    }
    this.disableSubmitbutton = false;
    this.$showLoader(false);
    if (response) {
      if (response.data.duplicates) {
        if (response.data.duplicates.emailExists) {
          this.user.isEmailVerified = false;
        }
        if (response.data.duplicates.phoneExists) {
          this.user.isPhoneVerified = false;
        }
        await this.$store.dispatch("updateStore", {
          emailExist: response.data.duplicates.emailExists,
          subdomainExist: response.data.duplicates.subdomainExists,
          phoneExist: response.data.duplicates.phoneExists,
          userNameExist: response.data.duplicates.userNameExists,
        });
        this.$emit("goToGeneral", true);
      } else {
        this.$snotify.success(response.data.message);
        this.$router.go(-1);
      }
    }
  }
  public updateSelectedView(views) {
    this.filteredViews = views;
  }

  public getUserById() {
    let identity = JSON.parse(JSON.stringify(this.user.views));
    this.accessRight = identity;
  }

  mounted() {
    this.getUserById();
  }
}
